// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OrdersDetailsV2.css */
/* ===== Base & Layout ===== */
.od-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 72px);
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
  color: #0f172a;
  margin-top: 70px;
  width: 100%;
}

.od-scroll-area {
  flex: 1;
  overflow: hidden;
  padding-bottom: 70px;
}

.od-scroll-inner {
  height: 100%;
  overflow-y: auto;
}

/* ===== Sticky Header ===== */
.od-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.od-header-inner {
  max-width: 1480px;
  margin: 0 auto;
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

@media (min-width: 1280px) {
  .od-header-inner {
    padding: 16px 32px;
  }
}

.od-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
  text-decoration: none;
}

.od-back-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

@media (min-width: 1024px) {
  .od-back-btn {
    width: 44px;
    height: 44px;
  }
}

.od-back-btn svg {
  width: 20px;
  height: 20px;
}

.od-header-title-wrap {
  min-width: 0;
  flex: 1;
}

.od-header-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.od-title {
  word-break: break-word;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  color: #020617;
  margin: 0;
}

@media (min-width: 1024px) {
  .od-title {
    font-size: 24px;
  }
}

/* ===== Badges ===== */
.od-badge {
  display: inline-flex;
  border-radius: 9999px;
  border: 1px solid;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.od-badge--delivered,
.od-badge--settled {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #065f46;
}

/* ===== Pricing Mode Badge (B2B orders) ===== */
.od-pricing-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.od-pricing-badge--retail {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.od-pricing-badge--wholesale {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

/* ===== Body Content ===== */
.od-body {
  max-width: 1480px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1280px) {
  .od-body {
    padding: 32px;
  }
}

/* ===== Top Row: Meta + Value Card ===== */
.od-top-row {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1024px) {
  .od-top-row {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.od-meta-card {
  flex: 1;
  min-width: 0;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

@media (min-width: 1024px) {
  .od-meta-card {
    padding: 20px;
  }
}

.od-meta-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}

@media (min-width: 1024px) {
  .od-meta-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.od-meta-cell {
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.8);
  padding: 12px 16px;
}

.od-meta-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
  word-break: break-word;
  overflow-wrap: break-word;
}

.od-meta-value {
  margin-top: 8px;
  word-break: break-word;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.od-meta-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
  word-break: break-word;
  overflow-wrap: break-word;
}

.od-value-card {
  width: 100%;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.05);
}

@media (min-width: 640px) {
  .od-value-card {
    max-width: 340px;
  }
}

@media (min-width: 1024px) {
  .od-value-card {
    width: 320px;
    flex-shrink: 0;
  }
}

@media (min-width: 1280px) {
  .od-value-card {
    width: 340px;
  }
}

.od-value-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-value-amount {
  margin-top: 8px;
  font-size: 30px;
  font-weight: 700;
  color: #020617;
}

.od-value-meta {
  margin-top: 12px;
  display: grid;
  gap: 4px;
  font-size: 12px;
  color: #64748b;
}

.od-value-meta span {
  font-weight: 600;
  color: #334155;
}

.od-invoice-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  margin-top: 20px;
  height: 44px;
  width: 100%;
  border-radius: 16px;
  background: #2a71ff;
  color: #ffffff;
  border: none;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.22);
  transition: background 0.15s;
}

.od-invoice-btn:hover {
  background: #1f63ea;
}

.od-invoice-btn svg {
  width: 16px;
  height: 16px;
}

/* ===== Main Grid: Timeline + Content ===== */
.od-main-grid {
  display: grid;
  gap: 24px;
}

@media (min-width: 1024px) {
  .od-main-grid {
    grid-template-columns: 260px minmax(0, 1fr);
  }
}

@media (min-width: 1280px) {
  .od-main-grid {
    grid-template-columns: 280px minmax(0, 1fr);
  }
}

/* ===== Timeline Card ===== */
.od-timeline-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

@media (min-width: 1024px) {
  .od-timeline-card {
    align-self: start;
  }
}

.od-timeline-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.od-timeline-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 16px;
  background: #eff6ff;
  color: #2a71ff;
  flex-shrink: 0;
}

.od-timeline-icon svg {
  width: 20px;
  height: 20px;
}

.od-timeline-header-text-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-timeline-header-text-title {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 700;
  color: #020617;
}

.od-timeline-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.od-timeline-item {
  position: relative;
  padding-left: 44px;
}

.od-timeline-item:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 40px;
  width: 1px;
  height: calc(100% + 12px);
  background: #e2e8f0;
}

.od-timeline-dot {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.od-timeline-dot svg {
  width: 16px;
  height: 16px;
}

.od-timeline-event-name {
  font-weight: 600;
  color: #0f172a;
  font-size: 14px;
  margin: 0;
  word-break: break-all;
  overflow-wrap: break-word;
}

.od-timeline-event-by {
  margin-top: 4px;
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 0;
  word-break: break-all;
  overflow-wrap: break-word;
}

.od-timeline-event-time {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 0;
}

/* ===== Right Column ===== */
.od-right-col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===== Shared Panel ===== */
.od-panel {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

@media (min-width: 1024px) {
  .od-panel {
    padding: 20px;
  }
}

.od-panel-title {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-panel-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
}

/* ===== More Order Details ===== */
.od-details-grid {
  margin-top: 16px;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}

@media (min-width: 1024px) {
  .od-details-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* ===== Address Grid ===== */
.od-address-grid {
  display: grid;
  gap: 16px;
}

@media (min-width: 1024px) {
  .od-address-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.od-address-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.od-address-card address {
  font-style: normal;
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.75;
  color: #475569;
}

/* ===== Tab Pill Row ===== */
.od-tabs-scroll {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.od-tabs-scroll::-webkit-scrollbar {
  display: none;
}

.od-tabs-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: max-content;
}

.od-tab-btn {
  white-space: nowrap;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    border-color 0.15s,
    color 0.15s;
  background: #ffffff;
  color: #64748b;
}

.od-tab-btn:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.od-tab-btn--active {
  border-color: #2a71ff;
  background: #eff6ff;
  color: #2a71ff;
  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.12);
}

/* ===== Tab Content Panel ===== */
.od-tab-content {
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

/* ===== Grid-based "table" rows ===== */
.od-grid-table {
  display: grid;
}

.od-grid-table-head {
  display: grid;
  grid-template-columns: var(--od-cols);
  border-bottom: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
  padding: 0 20px;
  /* overflow-x: auto; */
}

.od-grid-table-body {
  /* overflow-x: auto; */
}

.od-items-body-scroll {
  max-height: 480px;
  overflow-y: auto;
}

.od-items-body-scroll::-webkit-scrollbar {
  width: 6px;
}

.od-items-body-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.od-table-scroll {
  overflow-x: auto;
  width: 100%;
}

.od-grid-table{
  min-width: 560px;
}
.od-grid-table.od-cols-order-details {
  min-width: 860px; /* 820px columns + 40px row padding — order details only */
}

.od-table-scroll::-webkit-scrollbar {
  height: 6px;
}

.od-table-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.od-grid-table-row {
  display: grid;
  grid-template-columns: var(--od-cols);
  border-bottom: 1px solid #f1f5f9;
  padding: 0 20px;
  align-items: start;
}

.od-grid-table-row:last-child {
  border-bottom: none;
}

.od-grid-th {
  padding: 14px 12px 14px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
  /* white-space: nowrap; */
}

.od-grid-th:last-child,
.od-grid-td:last-child {
  text-align: right;
}

.od-grid-td {
  padding: 14px 12px 14px 0;
  font-size: 14px;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.od-grid-td--name {
  font-weight: 600;
  color: #0f172a;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: unset;
}

.od-grid-td--amount {
  font-weight: 600;
  color: #0f172a;
  text-align: right;
}

.od-grid-td--discount {
  color: #059669;
}

/* Order Details tab: 8 columns — Item column gets more space to wrap */
.od-cols-order-details {
  --od-cols: 22% 12% 10% 10% 10% 12% 12% 12%;
}

/* Discount tab: 6 columns */
.od-cols-discount {
  --od-cols: 18% 18% 16% 17% 19% 14%;
}

/* ===== Empty State ===== */
.od-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #94a3b8;
  text-align: center;
}

.od-empty-state svg {
  opacity: 0.5;
  margin-bottom: 12px;
}

.od-empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  margin: 0;
}

.od-empty-state-sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
  margin-bottom: 0;
}

/* ===== Tab Panel Header ===== */
.od-tab-panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.od-tab-panel-header-title {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

/* ===== Detailed View: 3-col stat cards ===== */
.od-stat-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

@media (min-width: 1024px) {
  .od-stat-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.od-stat-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.od-stat-card-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-stat-card-value {
  margin-top: 12px;
  font-size: 24px;
  font-weight: 700;
  color: #020617;
  margin-bottom: 0;
}

.od-stat-card-sub {
  margin-top: 8px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 0;
}

/* ===== Shipment Tab: 2-col layout ===== */
.od-two-col-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

@media (min-width: 1024px) {
  .od-two-col-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.od-info-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.od-info-card-title {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

/* Shipment kv rows */
.od-kv-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.od-kv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #475569;
}

.od-kv-row span:last-child {
  font-weight: 600;
  color: #0f172a;
}

/* Delivery address blocks */
.od-addr-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== Header Action Buttons ===== */
.od-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}

.od-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  height: 40px;
  padding: 0 18px;
  border-radius: 9999px;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
  letter-spacing: 0.02em;
}

.od-action-btn svg {
  width: 16px;
  height: 16px;
}

.od-action-btn--secondary {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.od-action-btn--secondary:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}

.od-action-btn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: auto;
}
.od-action-btn--disabled:hover {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.od-action-btn--primary {
  border: none;
  background: #2a71ff;
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.2);
}

.od-action-btn--primary:hover {
  background: #1f63ea;
}

/* Record Payment standalone button — amber/orange to stand out */
.od-action-btn--pay {
  border: none;
  background: #f59e0b;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);
}
.od-action-btn--pay:hover {
  background: #d97706;
}
.dark .od-action-btn--pay {
  background: #b45309;
}
.dark .od-action-btn--pay:hover {
  background: #92400e;
}

/* ── Inline PDF Invoice Viewer overlay ── */
.od-invoice-viewer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1800;
  display: flex;
  flex-direction: column;
  background: #0f172a;
}

.od-invoice-viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #1e293b;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
  gap: 12px;
}

.od-invoice-viewer-title {
  font-size: 14px;
  font-weight: 600;
  color: #f1f5f9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.od-invoice-viewer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.od-invoice-viewer-close {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.08);
  color: #f1f5f9;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.od-invoice-viewer-close:hover {
  background: rgba(255, 255, 255, 0.14);
}

.od-invoice-viewer-frame {
  flex: 1;
  width: 100%;
  border: none;
  background: #fff;
}

/* ===== Bill Drawer ===== */
.od-drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1555;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.od-bill-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  width: 92vw;
  max-width: 560px;
  background: #f3efe7;
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 28px 0 90px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.od-bill-drawer--open {
  transform: translateX(0);
}

.od-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  background: #f3efe7;
  flex-shrink: 0;
}

.od-drawer-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.od-drawer-label {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}

.od-drawer-id {
  font-size: 13px;
  font-weight: 600;
  color: #2a71ff;
  margin: 0;
}

.od-drawer-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.bill-layout-template-section {
  margin-left: auto;
  margin-right: auto;

  max-width: 440px;

  border-radius: 28px;

  border: 1px solid rgba(226, 232, 240, 0.9);

  background: #ffffff;

  padding: 24px;

  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
}

/* ===== Drawer Close Button ===== */
.od-drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.od-drawer-close-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}

/* ===== Receipt Card ===== */
.od-receipt-card {
  max-width: 440px;
  margin: 0 auto;
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
}

.od-receipt-store-header {
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 1px dashed #e2e8f0;
}

.od-receipt-brand {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: #2a71ff;
  margin: 0;
}

.od-receipt-store-name {
  margin: 8px 0 0;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #020617;
}

.od-receipt-store-meta {
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.6;
}

.od-receipt-store-meta p {
  margin: 2px 0;
}

.od-receipt-invoice-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #020617;
  padding: 12px 0;
  margin: 0;
}

.od-receipt-divider {
  border: none;
  border-top: 1px dashed #e2e8f0;
  margin: 0;
}

.od-receipt-meta {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  color: #475569;
  border-bottom: 1px dashed #e2e8f0;
}

.od-receipt-meta-row {
  display: flex;
  justify-content: space-between;
}

.od-receipt-meta-row span:last-child {
  font-weight: 600;
  color: #0f172a;
}

.od-receipt-items-head {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 48px 70px 70px;
  gap: 8px;
  padding: 12px 0 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-receipt-items-head span:not(:first-child),
.od-receipt-item-row span:not(:first-child) {
  text-align: right;
}

.od-receipt-item-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 48px 70px 70px;
  gap: 8px;
  padding: 8px 0;
  font-size: 13px;
  color: #475569;
  border-bottom: 1px solid #f8fafc;
}

.od-receipt-item-name {
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.od-receipt-totals {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  color: #475569;
}

.od-receipt-total-row {
  display: flex;
  justify-content: space-between;
}

.od-receipt-grand-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  font-size: 16px;
  font-weight: 700;
  color: #020617;
}

.od-receipt-footer {
  padding-top: 16px;
  text-align: center;
  font-size: 12px;
  color: #64748b;
  line-height: 1.6;
}

.od-receipt-footer p {
  margin: 2px 0;
}

.od-addr-block-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.od-addr-block-text {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.6;
  color: #475569;
  margin-bottom: 0;
}

/* ===== Order Summary (shared) ===== */
.od-summary-grid {
  margin-top: 20px;
  display: grid;
  gap: 12px;
  font-size: 14px;
  color: #475569;
}

@media (min-width: 640px) {
  .od-summary-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.od-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
  padding: 12px 16px;
}

.od-summary-row span:last-child {
  font-weight: 600;
  color: #0f172a;
}

.od-summary-divider {
  margin: 16px 0;
  border: none;
  border-top: 1px dashed #e2e8f0;
}

.od-summary-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.od-summary-total-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-summary-total-amount {
  font-size: 24px;
  font-weight: 700;
  color: #020617;
}

/* ===== Payment Card ===== */
.od-payment-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.od-payment-inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 22px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.6);
  padding: 16px;
}

@media (min-width: 1024px) {
  .od-payment-inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.od-payment-id {
  font-weight: 600;
  color: #0f172a;
  font-size: 14px;
  margin: 0;
}

.od-payment-sub {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 0;
}

.od-payment-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.od-payment-amount {
  font-size: 18px;
  font-weight: 700;
  color: #020617;
  margin: 0;
}

/* Tab panel wrapper that holds content + summary+payment */
.tabPanel-order {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===== Review Grid ===== */
.od-review-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

@media (min-width: 1024px) {
  .od-review-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.od-review-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.od-review-card-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #94a3b8;
}

.od-review-card-text {
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.75;
  color: #475569;
}

/* ══════════════════════════════════════════
   B2B / GST DETAILS TAB
══════════════════════════════════════════ */

/* B2B badge in header */
.od-b2b-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
  margin-left: 8px;
  white-space: nowrap;
}
.dark .od-b2b-badge {
  background: rgba(217,119,6,0.18);
  color: #fcd34d;
  border-color: rgba(217,119,6,0.3);
}

/* Partner + address 3-col grid */
.od-b2b-addr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-bottom: 4px;
}

.od-b2b-addr-block {
  font-style: normal;
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
}
.od-b2b-addr-phone,
.od-b2b-addr-gstin {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}
.od-b2b-addr-gstin {
  font-family: monospace;
  letter-spacing: 0.04em;
  color: #2a71ff;
}
.dark .od-b2b-addr-block,
.dark .od-b2b-addr-phone,
.dark .od-b2b-addr-gstin { color: #94a3b8; }
.dark .od-b2b-addr-gstin { color: #93c5fd; }

/* GST Breakup table: 6 cols */
.od-cols-gst {
  --od-cols: 2fr 2fr 2fr 2fr 2fr 2fr;
}
.od-grid-table.od-cols-gst {
  min-width: 560px;
}

/* GST totals footer row */
.od-gst-totals-row {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr;
  gap: 0;
  padding: 10px 12px;
  background: #f1f5f9;
  border-top: 2px solid #e2e8f0;
  border-radius: 0 0 8px 8px;
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}
.dark .od-gst-totals-row {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.08);
  color: #f8fafc;
}

/* GST slab badge */
.od-gst-slab-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #eff6ff;
  color: #1e40af;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #bfdbfe;
}
.dark .od-gst-slab-badge {
  background: rgba(59,130,246,0.15);
  color: #93c5fd;
  border-color: rgba(59,130,246,0.25);
}

/* Slab group container */
.od-gst-slab-group {
  margin-bottom: 18px;
}
.od-gst-slab-label {
  padding: 6px 0 10px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

/* Items-by-slab table: 9 cols */
.od-cols-gst-items {
  --od-cols: 3fr 1.5fr 1.5fr 1fr 1fr 1fr 1.5fr 1.5fr 1.5fr;
}
.od-grid-table.od-cols-gst-items {
  min-width: 820px;
}

/* ══════════════════════════════════════════
   B2B ACTIONS MENU
══════════════════════════════════════════ */

.od-b2b-menu-wrap {
  position: relative;
}

.od-b2b-menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 99;
}

.od-b2b-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 190px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  padding: 6px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dark .od-b2b-dropdown {
  background: #1e293b;
  border-color: rgba(255,255,255,0.08);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}

.od-b2b-dropdown-item {
  all: unset;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
  transition: background 0.12s;
}
.od-b2b-dropdown-item:hover {
  background: #f1f5f9;
}
.dark .od-b2b-dropdown-item { color: #f1f5f9; }
.dark .od-b2b-dropdown-item:hover { background: rgba(255,255,255,0.06); }

.od-b2b-dropdown-item--highlight {
  color: #065f46;
  font-weight: 600;
}
.od-b2b-dropdown-item--highlight:hover {
  background: #d1fae5;
}
.dark .od-b2b-dropdown-item--highlight { color: #6ee7b7; }
.dark .od-b2b-dropdown-item--highlight:hover { background: rgba(52,211,153,0.12); }

.od-b2b-dropdown-empty {
  display: block;
  padding: 10px 12px;
  font-size: 12px;
  color: #94a3b8;
  font-style: italic;
}

/* ══════════════════════════════════════════
   RECORD PAYMENT MODAL
══════════════════════════════════════════ */

.od-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(2px);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.od-modal-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  padding: 28px 28px 24px;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.dark .od-modal-card {
  background: #1e293b;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.od-modal-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.dark .od-modal-title { color: #f8fafc; }

.od-modal-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: -10px 0 0;
}
.dark .od-modal-subtitle { color: #94a3b8; }

.od-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.od-modal-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dark .od-modal-label { color: #94a3b8; }

.od-modal-input {
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 15px;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  transition: border-color 0.15s;
}
.od-modal-input:focus { border-color: #2a71ff; }
.dark .od-modal-input {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.1);
  color: #f8fafc;
}

.od-modal-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.od-modal-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
}
.od-modal-radio input { display: none; }
.od-modal-radio--selected {
  border-color: #2a71ff;
  background: #eff6ff;
  color: #1e40af;
}
.dark .od-modal-radio {
  border-color: rgba(255,255,255,0.1);
  color: #94a3b8;
}
.dark .od-modal-radio--selected {
  border-color: #3b82f6;
  background: rgba(59,130,246,0.15);
  color: #93c5fd;
}

.od-modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
}

.od-modal-btn {
  padding: 9px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.15s, opacity 0.15s;
}
.od-modal-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.od-modal-btn--cancel {
  background: #f1f5f9;
  color: #475569;
}
.od-modal-btn--cancel:hover:not(:disabled) { background: #e2e8f0; }
.od-modal-btn--confirm {
  background: #2a71ff;
  color: #fff;
}
.od-modal-btn--confirm:hover:not(:disabled) { background: #1a5fe0; }
.dark .od-modal-btn--cancel { background: rgba(255,255,255,0.07); color: #94a3b8; }
.dark .od-modal-btn--cancel:hover:not(:disabled) { background: rgba(255,255,255,0.12); }

/* ══════════════════════════════════════════
   COMMENTS SECTION
══════════════════════════════════════════ */

.od-comments-section {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}
.dark .od-comments-section {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.07);
}

.od-comments-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 12px;
  border-bottom: 1px solid #f1f5f9;
}
.dark .od-comments-header { border-color: rgba(255,255,255,0.06); }

.od-comments-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.dark .od-comments-title { color: #f8fafc; }

.od-comments-count {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 999px;
}
.dark .od-comments-count { background: rgba(255,255,255,0.06); }

.od-comments-list {
  max-height: 280px;
  overflow-y: auto;
  padding: 8px 0;
}

.od-comments-empty {
  padding: 16px 18px;
  font-size: 13px;
  color: #94a3b8;
  font-style: italic;
}

.od-comment-item {
  padding: 10px 18px;
  border-bottom: 1px solid #f8fafc;
}
.od-comment-item:last-child { border-bottom: none; }
.dark .od-comment-item { border-color: rgba(255,255,255,0.04); }

.od-comment-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.od-comment-author {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}
.dark .od-comment-author { color: #cbd5e1; }

.od-comment-time {
  font-size: 11px;
  color: #94a3b8;
}

.od-comment-text {
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}
.dark .od-comment-text { color: #94a3b8; }

.od-comment-form {
  display: flex;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid #f1f5f9;
  align-items: flex-end;
}
.dark .od-comment-form { border-color: rgba(255,255,255,0.06); }

.od-comment-input {
  flex: 1;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #0f172a;
  background: #f8fafc;
  resize: none;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s;
}
.od-comment-input:focus { border-color: #2a71ff; }
.dark .od-comment-input {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.1);
  color: #f1f5f9;
}

.od-comment-submit {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 14px;
  border-radius: 8px;
  background: #2a71ff;
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, opacity 0.15s;
  flex-shrink: 0;
  align-self: flex-end;
  height: fit-content;
}
.od-comment-submit:hover:not(:disabled) { background: #1a5fe0; }
.od-comment-submit:disabled { opacity: 0.4; cursor: not-allowed; }
.od-comment-submit svg { width: 14px; height: 14px; }

/* ── Loading state ── */
.od-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-size: 14px;
  color: #64748b;
  gap: 10px;
}

.od-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top-color: #2a71ff;
  border-radius: 50%;
  animation: od-spin 0.7s linear infinite;
}

@keyframes od-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/OrdersV2/OrdersDetailsV2.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB;qDACmD;EACnD,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,iGAAiG;EACjG,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;;oBAEkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;EAChC;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf;;eAEa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB,EAAE,0DAA0D;AAC9E;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf;;sBAEoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,0CAA0C;;EAE1C,mBAAmB;;EAEnB,aAAa;;EAEb,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd;;;eAGa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;4CAE4C;;AAE5C,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;AACA;;2BAE2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;;AAE3C,8BAA8B;AAC9B;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8CAA8C;EAC9C,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,cAAc;EACd,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,wDAAwD;AAC1D;AACA;EACE,gBAAgB;AAClB;;AAEA;;4CAE4C;;AAE5C;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA,8BAA8B,cAAc,EAAE;AAC9C,oCAAoC,kCAAkC,EAAE;;AAExE;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA,yCAAyC,cAAc,EAAE;AACzD,+CAA+C,iCAAiC,EAAE;;AAElF;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;4CAE4C;;AAE5C;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA,wBAAwB,qBAAqB,EAAE;AAC/C;EACE,kCAAkC;EAClC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;AACA,wBAAwB,aAAa,EAAE;AACvC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;AACA,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;AAC5D;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,6CAA6C,mBAAmB,EAAE;AAClE;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,8CAA8C,mBAAmB,EAAE;AACnE,8BAA8B,kCAAkC,EAAE,cAAc,EAAE;AAClF,mDAAmD,kCAAkC,EAAE;;AAEvF;;4CAE4C;;AAE5C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;AACA,4BAA4B,oCAAoC,EAAE;;AAElE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,2BAA2B,kCAAkC,EAAE;;AAE/D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA,8BAA8B,mBAAmB,EAAE;AACnD,yBAAyB,oCAAoC,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,yBAAyB,oCAAoC,EAAE;;AAE/D;EACE,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;AACA,0BAA0B,qBAAqB,EAAE;AACjD;EACE,kCAAkC;EAClC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,yBAAyB,WAAW,EAAE,YAAY,EAAE;;AAEpD,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* OrdersDetailsV2.css */\n/* ===== Base & Layout ===== */\n.od-page {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 72px);\n  overflow: hidden;\n  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),\n    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);\n  color: #0f172a;\n  margin-top: 70px;\n  width: 100%;\n}\n\n.od-scroll-area {\n  flex: 1;\n  overflow: hidden;\n  padding-bottom: 70px;\n}\n\n.od-scroll-inner {\n  height: 100%;\n  overflow-y: auto;\n}\n\n/* ===== Sticky Header ===== */\n.od-header {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.7);\n  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n.od-header-inner {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 16px 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n@media (min-width: 1280px) {\n  .od-header-inner {\n    padding: 16px 32px;\n  }\n}\n\n.od-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n  text-decoration: none;\n}\n\n.od-back-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n@media (min-width: 1024px) {\n  .od-back-btn {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n.od-back-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.od-header-title-wrap {\n  min-width: 0;\n  flex: 1;\n}\n\n.od-header-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.od-title {\n  word-break: break-word;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #020617;\n  margin: 0;\n}\n\n@media (min-width: 1024px) {\n  .od-title {\n    font-size: 24px;\n  }\n}\n\n/* ===== Badges ===== */\n.od-badge {\n  display: inline-flex;\n  border-radius: 9999px;\n  border: 1px solid;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.od-badge--delivered,\n.od-badge--settled {\n  border-color: #a7f3d0;\n  background: #ecfdf5;\n  color: #065f46;\n}\n\n/* ===== Pricing Mode Badge (B2B orders) ===== */\n.od-pricing-badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.od-pricing-badge--retail {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.od-pricing-badge--wholesale {\n  border-color: #fde68a;\n  background: #fffbeb;\n  color: #92400e;\n}\n\n/* ===== Body Content ===== */\n.od-body {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 1280px) {\n  .od-body {\n    padding: 32px;\n  }\n}\n\n/* ===== Top Row: Meta + Value Card ===== */\n.od-top-row {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .od-top-row {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n}\n\n.od-meta-card {\n  flex: 1;\n  min-width: 0;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 16px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n@media (min-width: 1024px) {\n  .od-meta-card {\n    padding: 20px;\n  }\n}\n\n.od-meta-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr 1fr;\n}\n\n@media (min-width: 1024px) {\n  .od-meta-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.od-meta-cell {\n  border-radius: 20px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.8);\n  padding: 12px 16px;\n}\n\n.od-meta-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.od-meta-value {\n  margin-top: 8px;\n  word-break: break-word;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.od-meta-sub {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #64748b;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.od-value-card {\n  width: 100%;\n  border-radius: 24px;\n  border: 1px solid #f1f5f9;\n  background: #ffffff;\n  padding: 20px;\n  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.05);\n}\n\n@media (min-width: 640px) {\n  .od-value-card {\n    max-width: 340px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .od-value-card {\n    width: 320px;\n    flex-shrink: 0;\n  }\n}\n\n@media (min-width: 1280px) {\n  .od-value-card {\n    width: 340px;\n  }\n}\n\n.od-value-label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-value-amount {\n  margin-top: 8px;\n  font-size: 30px;\n  font-weight: 700;\n  color: #020617;\n}\n\n.od-value-meta {\n  margin-top: 12px;\n  display: grid;\n  gap: 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.od-value-meta span {\n  font-weight: 600;\n  color: #334155;\n}\n\n.od-invoice-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 20px;\n  height: 44px;\n  width: 100%;\n  border-radius: 16px;\n  background: #2a71ff;\n  color: #ffffff;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.22);\n  transition: background 0.15s;\n}\n\n.od-invoice-btn:hover {\n  background: #1f63ea;\n}\n\n.od-invoice-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ===== Main Grid: Timeline + Content ===== */\n.od-main-grid {\n  display: grid;\n  gap: 24px;\n}\n\n@media (min-width: 1024px) {\n  .od-main-grid {\n    grid-template-columns: 260px minmax(0, 1fr);\n  }\n}\n\n@media (min-width: 1280px) {\n  .od-main-grid {\n    grid-template-columns: 280px minmax(0, 1fr);\n  }\n}\n\n/* ===== Timeline Card ===== */\n.od-timeline-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n@media (min-width: 1024px) {\n  .od-timeline-card {\n    align-self: start;\n  }\n}\n\n.od-timeline-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.od-timeline-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 16px;\n  background: #eff6ff;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n.od-timeline-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.od-timeline-header-text-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-timeline-header-text-title {\n  margin-top: 4px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #020617;\n}\n\n.od-timeline-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.od-timeline-item {\n  position: relative;\n  padding-left: 44px;\n}\n\n.od-timeline-item:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 18px;\n  top: 40px;\n  width: 1px;\n  height: calc(100% + 12px);\n  background: #e2e8f0;\n}\n\n.od-timeline-dot {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.od-timeline-dot svg {\n  width: 16px;\n  height: 16px;\n}\n\n.od-timeline-event-name {\n  font-weight: 600;\n  color: #0f172a;\n  font-size: 14px;\n  margin: 0;\n  word-break: break-all;\n  overflow-wrap: break-word;\n}\n\n.od-timeline-event-by {\n  margin-top: 4px;\n  font-size: 10px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 0;\n  word-break: break-all;\n  overflow-wrap: break-word;\n}\n\n.od-timeline-event-time {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n/* ===== Right Column ===== */\n.od-right-col {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ===== Shared Panel ===== */\n.od-panel {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 16px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n@media (min-width: 1024px) {\n  .od-panel {\n    padding: 20px;\n  }\n}\n\n.od-panel-title {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-panel-subtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* ===== More Order Details ===== */\n.od-details-grid {\n  margin-top: 16px;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr 1fr;\n}\n\n@media (min-width: 1024px) {\n  .od-details-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* ===== Address Grid ===== */\n.od-address-grid {\n  display: grid;\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .od-address-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.od-address-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n.od-address-card address {\n  font-style: normal;\n  margin-top: 16px;\n  font-size: 14px;\n  line-height: 1.75;\n  color: #475569;\n}\n\n/* ===== Tab Pill Row ===== */\n.od-tabs-scroll {\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.od-tabs-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.od-tabs-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: max-content;\n}\n\n.od-tab-btn {\n  white-space: nowrap;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    color 0.15s;\n  background: #ffffff;\n  color: #64748b;\n}\n\n.od-tab-btn:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.od-tab-btn--active {\n  border-color: #2a71ff;\n  background: #eff6ff;\n  color: #2a71ff;\n  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.12);\n}\n\n/* ===== Tab Content Panel ===== */\n.od-tab-content {\n  overflow: hidden;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n/* ===== Grid-based \"table\" rows ===== */\n.od-grid-table {\n  display: grid;\n}\n\n.od-grid-table-head {\n  display: grid;\n  grid-template-columns: var(--od-cols);\n  border-bottom: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n  padding: 0 20px;\n  /* overflow-x: auto; */\n}\n\n.od-grid-table-body {\n  /* overflow-x: auto; */\n}\n\n.od-items-body-scroll {\n  max-height: 480px;\n  overflow-y: auto;\n}\n\n.od-items-body-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.od-items-body-scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 999px;\n}\n\n.od-table-scroll {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.od-grid-table{\n  min-width: 560px;\n}\n.od-grid-table.od-cols-order-details {\n  min-width: 860px; /* 820px columns + 40px row padding — order details only */\n}\n\n.od-table-scroll::-webkit-scrollbar {\n  height: 6px;\n}\n\n.od-table-scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 999px;\n}\n\n.od-grid-table-row {\n  display: grid;\n  grid-template-columns: var(--od-cols);\n  border-bottom: 1px solid #f1f5f9;\n  padding: 0 20px;\n  align-items: start;\n}\n\n.od-grid-table-row:last-child {\n  border-bottom: none;\n}\n\n.od-grid-th {\n  padding: 14px 12px 14px 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  /* white-space: nowrap; */\n}\n\n.od-grid-th:last-child,\n.od-grid-td:last-child {\n  text-align: right;\n}\n\n.od-grid-td {\n  padding: 14px 12px 14px 0;\n  font-size: 14px;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.od-grid-td--name {\n  font-weight: 600;\n  color: #0f172a;\n  white-space: normal;\n  word-break: break-word;\n  overflow: visible;\n  text-overflow: unset;\n}\n\n.od-grid-td--amount {\n  font-weight: 600;\n  color: #0f172a;\n  text-align: right;\n}\n\n.od-grid-td--discount {\n  color: #059669;\n}\n\n/* Order Details tab: 8 columns — Item column gets more space to wrap */\n.od-cols-order-details {\n  --od-cols: 22% 12% 10% 10% 10% 12% 12% 12%;\n}\n\n/* Discount tab: 6 columns */\n.od-cols-discount {\n  --od-cols: 18% 18% 16% 17% 19% 14%;\n}\n\n/* ===== Empty State ===== */\n.od-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.od-empty-state svg {\n  opacity: 0.5;\n  margin-bottom: 12px;\n}\n\n.od-empty-state-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  margin: 0;\n}\n\n.od-empty-state-sub {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n/* ===== Tab Panel Header ===== */\n.od-tab-panel-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.od-tab-panel-header-title {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n/* ===== Detailed View: 3-col stat cards ===== */\n.od-stat-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 1024px) {\n  .od-stat-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.od-stat-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n.od-stat-card-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-stat-card-value {\n  margin-top: 12px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #020617;\n  margin-bottom: 0;\n}\n\n.od-stat-card-sub {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n/* ===== Shipment Tab: 2-col layout ===== */\n.od-two-col-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 1024px) {\n  .od-two-col-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.od-info-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n.od-info-card-title {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n/* Shipment kv rows */\n.od-kv-list {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.od-kv-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #475569;\n}\n\n.od-kv-row span:last-child {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* Delivery address blocks */\n.od-addr-list {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ===== Header Action Buttons ===== */\n.od-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.od-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  height: 40px;\n  padding: 0 18px;\n  border-radius: 9999px;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  letter-spacing: 0.02em;\n}\n\n.od-action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.od-action-btn--secondary {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.od-action-btn--secondary:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.od-action-btn--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n.od-action-btn--disabled:hover {\n  opacity: 0.4;\n  cursor: not-allowed;\n  border-color: #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.od-action-btn--primary {\n  border: none;\n  background: #2a71ff;\n  color: #ffffff;\n  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.2);\n}\n\n.od-action-btn--primary:hover {\n  background: #1f63ea;\n}\n\n/* Record Payment standalone button — amber/orange to stand out */\n.od-action-btn--pay {\n  border: none;\n  background: #f59e0b;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);\n}\n.od-action-btn--pay:hover {\n  background: #d97706;\n}\n.dark .od-action-btn--pay {\n  background: #b45309;\n}\n.dark .od-action-btn--pay:hover {\n  background: #92400e;\n}\n\n/* ── Inline PDF Invoice Viewer overlay ── */\n.od-invoice-viewer-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1800;\n  display: flex;\n  flex-direction: column;\n  background: #0f172a;\n}\n\n.od-invoice-viewer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: #1e293b;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n  gap: 12px;\n}\n\n.od-invoice-viewer-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #f1f5f9;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.od-invoice-viewer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.od-invoice-viewer-close {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.08);\n  color: #f1f5f9;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.od-invoice-viewer-close:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.od-invoice-viewer-frame {\n  flex: 1;\n  width: 100%;\n  border: none;\n  background: #fff;\n}\n\n/* ===== Bill Drawer ===== */\n.od-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1555;\n  background: rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.od-bill-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  width: 92vw;\n  max-width: 560px;\n  background: #f3efe7;\n  border-right: 1px solid rgba(226, 232, 240, 0.8);\n  box-shadow: 28px 0 90px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.od-bill-drawer--open {\n  transform: translateX(0);\n}\n\n.od-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  background: #f3efe7;\n  flex-shrink: 0;\n}\n\n.od-drawer-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.od-drawer-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  margin: 0;\n}\n\n.od-drawer-id {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2a71ff;\n  margin: 0;\n}\n\n.od-drawer-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.bill-layout-template-section {\n  margin-left: auto;\n  margin-right: auto;\n\n  max-width: 440px;\n\n  border-radius: 28px;\n\n  border: 1px solid rgba(226, 232, 240, 0.9);\n\n  background: #ffffff;\n\n  padding: 24px;\n\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n}\n\n/* ===== Drawer Close Button ===== */\n.od-drawer-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.od-drawer-close-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n/* ===== Receipt Card ===== */\n.od-receipt-card {\n  max-width: 440px;\n  margin: 0 auto;\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  background: #ffffff;\n  padding: 24px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n}\n\n.od-receipt-store-header {\n  text-align: center;\n  padding-bottom: 16px;\n  border-bottom: 1px dashed #e2e8f0;\n}\n\n.od-receipt-brand {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.24em;\n  text-transform: uppercase;\n  color: #2a71ff;\n  margin: 0;\n}\n\n.od-receipt-store-name {\n  margin: 8px 0 0;\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: #020617;\n}\n\n.od-receipt-store-meta {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.od-receipt-store-meta p {\n  margin: 2px 0;\n}\n\n.od-receipt-invoice-title {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: #020617;\n  padding: 12px 0;\n  margin: 0;\n}\n\n.od-receipt-divider {\n  border: none;\n  border-top: 1px dashed #e2e8f0;\n  margin: 0;\n}\n\n.od-receipt-meta {\n  padding: 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 13px;\n  color: #475569;\n  border-bottom: 1px dashed #e2e8f0;\n}\n\n.od-receipt-meta-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.od-receipt-meta-row span:last-child {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.od-receipt-items-head {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) 48px 70px 70px;\n  gap: 8px;\n  padding: 12px 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-receipt-items-head span:not(:first-child),\n.od-receipt-item-row span:not(:first-child) {\n  text-align: right;\n}\n\n.od-receipt-item-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) 48px 70px 70px;\n  gap: 8px;\n  padding: 8px 0;\n  font-size: 13px;\n  color: #475569;\n  border-bottom: 1px solid #f8fafc;\n}\n\n.od-receipt-item-name {\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.od-receipt-totals {\n  padding: 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.od-receipt-total-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.od-receipt-grand-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #020617;\n}\n\n.od-receipt-footer {\n  padding-top: 16px;\n  text-align: center;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.od-receipt-footer p {\n  margin: 2px 0;\n}\n\n.od-addr-block-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.od-addr-block-text {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #475569;\n  margin-bottom: 0;\n}\n\n/* ===== Order Summary (shared) ===== */\n.od-summary-grid {\n  margin-top: 20px;\n  display: grid;\n  gap: 12px;\n  font-size: 14px;\n  color: #475569;\n}\n\n@media (min-width: 640px) {\n  .od-summary-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.od-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n  padding: 12px 16px;\n}\n\n.od-summary-row span:last-child {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.od-summary-divider {\n  margin: 16px 0;\n  border: none;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.od-summary-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.od-summary-total-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-summary-total-amount {\n  font-size: 24px;\n  font-weight: 700;\n  color: #020617;\n}\n\n/* ===== Payment Card ===== */\n.od-payment-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n.od-payment-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border-radius: 22px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.6);\n  padding: 16px;\n}\n\n@media (min-width: 1024px) {\n  .od-payment-inner {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.od-payment-id {\n  font-weight: 600;\n  color: #0f172a;\n  font-size: 14px;\n  margin: 0;\n}\n\n.od-payment-sub {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 0;\n}\n\n.od-payment-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.od-payment-amount {\n  font-size: 18px;\n  font-weight: 700;\n  color: #020617;\n  margin: 0;\n}\n\n/* Tab panel wrapper that holds content + summary+payment */\n.tabPanel-order {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ===== Review Grid ===== */\n.od-review-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 1024px) {\n  .od-review-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.od-review-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);\n}\n\n.od-review-card-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.od-review-card-text {\n  margin-top: 16px;\n  font-size: 14px;\n  line-height: 1.75;\n  color: #475569;\n}\n\n/* ══════════════════════════════════════════\n   B2B / GST DETAILS TAB\n══════════════════════════════════════════ */\n\n/* B2B badge in header */\n.od-b2b-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n  margin-left: 8px;\n  white-space: nowrap;\n}\n.dark .od-b2b-badge {\n  background: rgba(217,119,6,0.18);\n  color: #fcd34d;\n  border-color: rgba(217,119,6,0.3);\n}\n\n/* Partner + address 3-col grid */\n.od-b2b-addr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 14px;\n  margin-bottom: 4px;\n}\n\n.od-b2b-addr-block {\n  font-style: normal;\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.6;\n}\n.od-b2b-addr-phone,\n.od-b2b-addr-gstin {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n.od-b2b-addr-gstin {\n  font-family: monospace;\n  letter-spacing: 0.04em;\n  color: #2a71ff;\n}\n.dark .od-b2b-addr-block,\n.dark .od-b2b-addr-phone,\n.dark .od-b2b-addr-gstin { color: #94a3b8; }\n.dark .od-b2b-addr-gstin { color: #93c5fd; }\n\n/* GST Breakup table: 6 cols */\n.od-cols-gst {\n  --od-cols: 2fr 2fr 2fr 2fr 2fr 2fr;\n}\n.od-grid-table.od-cols-gst {\n  min-width: 560px;\n}\n\n/* GST totals footer row */\n.od-gst-totals-row {\n  display: grid;\n  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr;\n  gap: 0;\n  padding: 10px 12px;\n  background: #f1f5f9;\n  border-top: 2px solid #e2e8f0;\n  border-radius: 0 0 8px 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f172a;\n}\n.dark .od-gst-totals-row {\n  background: rgba(255,255,255,0.04);\n  border-color: rgba(255,255,255,0.08);\n  color: #f8fafc;\n}\n\n/* GST slab badge */\n.od-gst-slab-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  background: #eff6ff;\n  color: #1e40af;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  border: 1px solid #bfdbfe;\n}\n.dark .od-gst-slab-badge {\n  background: rgba(59,130,246,0.15);\n  color: #93c5fd;\n  border-color: rgba(59,130,246,0.25);\n}\n\n/* Slab group container */\n.od-gst-slab-group {\n  margin-bottom: 18px;\n}\n.od-gst-slab-label {\n  padding: 6px 0 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n/* Items-by-slab table: 9 cols */\n.od-cols-gst-items {\n  --od-cols: 3fr 1.5fr 1.5fr 1fr 1fr 1fr 1.5fr 1.5fr 1.5fr;\n}\n.od-grid-table.od-cols-gst-items {\n  min-width: 820px;\n}\n\n/* ══════════════════════════════════════════\n   B2B ACTIONS MENU\n══════════════════════════════════════════ */\n\n.od-b2b-menu-wrap {\n  position: relative;\n}\n\n.od-b2b-menu-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 99;\n}\n\n.od-b2b-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 190px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.12);\n  padding: 6px;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dark .od-b2b-dropdown {\n  background: #1e293b;\n  border-color: rgba(255,255,255,0.08);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.4);\n}\n\n.od-b2b-dropdown-item {\n  all: unset;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.od-b2b-dropdown-item:hover {\n  background: #f1f5f9;\n}\n.dark .od-b2b-dropdown-item { color: #f1f5f9; }\n.dark .od-b2b-dropdown-item:hover { background: rgba(255,255,255,0.06); }\n\n.od-b2b-dropdown-item--highlight {\n  color: #065f46;\n  font-weight: 600;\n}\n.od-b2b-dropdown-item--highlight:hover {\n  background: #d1fae5;\n}\n.dark .od-b2b-dropdown-item--highlight { color: #6ee7b7; }\n.dark .od-b2b-dropdown-item--highlight:hover { background: rgba(52,211,153,0.12); }\n\n.od-b2b-dropdown-empty {\n  display: block;\n  padding: 10px 12px;\n  font-size: 12px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n/* ══════════════════════════════════════════\n   RECORD PAYMENT MODAL\n══════════════════════════════════════════ */\n\n.od-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  backdrop-filter: blur(2px);\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.od-modal-card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n  padding: 28px 28px 24px;\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.dark .od-modal-card {\n  background: #1e293b;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.5);\n}\n\n.od-modal-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.dark .od-modal-title { color: #f8fafc; }\n\n.od-modal-subtitle {\n  font-size: 13px;\n  color: #64748b;\n  margin: -10px 0 0;\n}\n.dark .od-modal-subtitle { color: #94a3b8; }\n\n.od-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.od-modal-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.dark .od-modal-label { color: #94a3b8; }\n\n.od-modal-input {\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 9px 12px;\n  font-size: 15px;\n  color: #0f172a;\n  background: #f8fafc;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.od-modal-input:focus { border-color: #2a71ff; }\n.dark .od-modal-input {\n  background: rgba(255,255,255,0.05);\n  border-color: rgba(255,255,255,0.1);\n  color: #f8fafc;\n}\n\n.od-modal-radio-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.od-modal-radio {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border-radius: 8px;\n  border: 1.5px solid #e2e8f0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s;\n}\n.od-modal-radio input { display: none; }\n.od-modal-radio--selected {\n  border-color: #2a71ff;\n  background: #eff6ff;\n  color: #1e40af;\n}\n.dark .od-modal-radio {\n  border-color: rgba(255,255,255,0.1);\n  color: #94a3b8;\n}\n.dark .od-modal-radio--selected {\n  border-color: #3b82f6;\n  background: rgba(59,130,246,0.15);\n  color: #93c5fd;\n}\n\n.od-modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.od-modal-btn {\n  padding: 9px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s, opacity 0.15s;\n}\n.od-modal-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.od-modal-btn--cancel {\n  background: #f1f5f9;\n  color: #475569;\n}\n.od-modal-btn--cancel:hover:not(:disabled) { background: #e2e8f0; }\n.od-modal-btn--confirm {\n  background: #2a71ff;\n  color: #fff;\n}\n.od-modal-btn--confirm:hover:not(:disabled) { background: #1a5fe0; }\n.dark .od-modal-btn--cancel { background: rgba(255,255,255,0.07); color: #94a3b8; }\n.dark .od-modal-btn--cancel:hover:not(:disabled) { background: rgba(255,255,255,0.12); }\n\n/* ══════════════════════════════════════════\n   COMMENTS SECTION\n══════════════════════════════════════════ */\n\n.od-comments-section {\n  margin-top: 20px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.dark .od-comments-section {\n  background: rgba(255,255,255,0.03);\n  border-color: rgba(255,255,255,0.07);\n}\n\n.od-comments-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.dark .od-comments-header { border-color: rgba(255,255,255,0.06); }\n\n.od-comments-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.dark .od-comments-title { color: #f8fafc; }\n\n.od-comments-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n.dark .od-comments-count { background: rgba(255,255,255,0.06); }\n\n.od-comments-list {\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.od-comments-empty {\n  padding: 16px 18px;\n  font-size: 13px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.od-comment-item {\n  padding: 10px 18px;\n  border-bottom: 1px solid #f8fafc;\n}\n.od-comment-item:last-child { border-bottom: none; }\n.dark .od-comment-item { border-color: rgba(255,255,255,0.04); }\n\n.od-comment-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.od-comment-author {\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n}\n.dark .od-comment-author { color: #cbd5e1; }\n\n.od-comment-time {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.od-comment-text {\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.5;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.dark .od-comment-text { color: #94a3b8; }\n\n.od-comment-form {\n  display: flex;\n  gap: 8px;\n  padding: 12px 14px;\n  border-top: 1px solid #f1f5f9;\n  align-items: flex-end;\n}\n.dark .od-comment-form { border-color: rgba(255,255,255,0.06); }\n\n.od-comment-input {\n  flex: 1;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  color: #0f172a;\n  background: #f8fafc;\n  resize: none;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.od-comment-input:focus { border-color: #2a71ff; }\n.dark .od-comment-input {\n  background: rgba(255,255,255,0.05);\n  border-color: rgba(255,255,255,0.1);\n  color: #f1f5f9;\n}\n\n.od-comment-submit {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: #2a71ff;\n  color: #fff;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, opacity 0.15s;\n  flex-shrink: 0;\n  align-self: flex-end;\n  height: fit-content;\n}\n.od-comment-submit:hover:not(:disabled) { background: #1a5fe0; }\n.od-comment-submit:disabled { opacity: 0.4; cursor: not-allowed; }\n.od-comment-submit svg { width: 14px; height: 14px; }\n\n/* ── Loading state ── */\n.od-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  font-size: 14px;\n  color: #64748b;\n  gap: 10px;\n}\n\n.od-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top-color: #2a71ff;\n  border-radius: 50%;\n  animation: od-spin 0.7s linear infinite;\n}\n\n@keyframes od-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
